// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hS","cusMtdicon":"hS"};